import * as React from "react";
const SvgFiRrArrowUpSquareTriangle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrow-up-square-triangle_svg__a)">
      <path
        fill="#062147"
        d="M17 10h3c1.654 0 3-1.346 3-3V4c0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v3c0 1.654 1.346 3 3 3m-1-6c0-.551.45-1 1-1h3c.551 0 1 .449 1 1v3c0 .551-.449 1-1 1h-3c-.55 0-1-.449-1-1zm7.196 15.583-2.689-4.387a2.28 2.28 0 0 0-2.007-1.195c-.838 0-1.608.458-1.98 1.149l-2.742 4.479a2.26 2.26 0 0 0 .046 2.256A2.27 2.27 0 0 0 15.786 23h5.43c.812 0 1.546-.417 1.962-1.115s.433-1.542.02-2.302zm-1.738 1.279a.27.27 0 0 1-.244.139h-5.43a.27.27 0 0 1-.244-.139c-.038-.063-.069-.163-.032-.234l2.741-4.479a.27.27 0 0 1 .25-.148c.078 0 .183.026.275.194l2.688 4.387a.27.27 0 0 1-.004.28m-9.75-14.569a1 1 0 0 0 0-1.414L7.413.586A2 2 0 0 0 6 0c-.512 0-1.024.195-1.414.585L.293 4.879a.999.999 0 1 0 1.414 1.414L5 3v20a1 1 0 1 0 2 0V3l3.293 3.293a1 1 0 0 0 1.414 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrow-up-square-triangle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowUpSquareTriangle;
